<template>
    <div>
        <ConfirmDialog
            :is-open="confirmDeleteLocalizationScreenGroupDialog"
            @on-confirm="deleteLocalizationScreenGroup"
            @on-abort="closeConfirmDeleteOutdoorsLocalizationScreenGroupDialog"
        >
            <template #title>
                Usuwanie grupy - <strong>{{ outdoorsLocalizationScreen.localizationScreenGroup.name }}</strong>
            </template>
            <template #content>
                Czy na pewno chcesz usunąć grupę?
            </template>
            <template #confirmButton>
                Usuń
            </template>
        </ConfirmDialog>

        <ConfirmDialog
            :is-open="confirmDeleteLocalizationScreenSizeDialog"
            :data="screenSize"
            @on-confirm="deleteLocalizationScreenSize"
            @on-abort="closeConfirmDeleteOutdoorsLocalizationScreenSizeDialog"
        >
            <template #title>
                Usuwanie wymiaru <strong>{{ outdoorsLocalizationScreen.localizationScreenSize.sizeA }} x {{ outdoorsLocalizationScreen.localizationScreenSize.sizeB }}</strong>
            </template>
            <template #content>
                Czy na pewno chcesz usunąć wymiar?
            </template>
            <template #confirmButton>
                Usuń
            </template>
        </ConfirmDialog>

        <OutdoorsLocalizationScreenGroupDialog
            :is-open="outdoorsLocalizationScreenGroupDialog"
            :screen-group-data="screenGroup"
            :outdoors-localization-screen-data="outdoorsLocalizationScreen"
            :customer-data="customerData"
            @update-screen="updateScreen"
            @get-outdoors-localization-screen-groups="getOutdoorsLocalizationScreenGroups"
            @on-close="closeOutdoorsLocalizationScreenGroupDialog"
        />

        <OutdoorsLocalizationScreenSizeDialog
            :is-open="outdoorsLocalizationScreenSizeDialog"
            :screen-size-data="screenSize"
            :outdoors-localization-screen-data="outdoorsLocalizationScreen"
            @update-screen="updateScreen"
            @get-outdoors-localization-screen-sizes="getOutdoorsLocalizationScreenSizes"
            @on-close="closeOutdoorsLocalizationScreenSizeDialog"
        />

        <v-dialog
            :value="isOpen"
            scrollable
            max-width="600px"
            transition="slide-y-transition"
            eager
            @keydown.esc="onClose"
            @click:outside="onClose"
        >
            <v-card>
                <v-card-title>
                    <h1 class="text-subtitle-1">
                        <template v-if="isNewScreen">
                            Tworzenie nowego ekranu
                        </template>
                        <template v-else>
                            Edycja ekranu
                        </template>
                    </h1>
                </v-card-title>

                <v-card-text>
                    <v-container class="pa-0">
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="outdoorsLocalizationScreen.ordinalNumber"
                                    label="Numer ekranu"
                                    outlined
                                    dense
                                    :error-messages="ordinalNumberErrors"
                                    required
                                />
                            </v-col>
                            <v-col cols="12">
                                <v-select
                                    :value="outdoorsLocalizationScreen.localizationScreenGroup"
                                    label="Grupa ekranu"
                                    :items="localizationScreenGroups"
                                    item-value="id"
                                    item-text="name"
                                    return-object
                                    no-data-text="Nie znaleziono grupy ekranu"
                                    :error-messages="localizationScreenGroupErrors"
                                    outlined
                                    dense
                                    required
                                    @change="changeLocalizationScreenGroup"
                                >
                                    <template slot="append-outer">
                                        <v-tooltip top :open-delay="tooltipDelay">
                                            <template #activator="{on}">
                                                <v-btn
                                                    icon
                                                    data-sentry-label="Dodaj grupę"
                                                    small
                                                    v-on="on"
                                                    @click="showCreateOutdoorsLocalizationScreenGroupDialog"
                                                >
                                                    <v-icon color="primary">
                                                        mdi-plus
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Dodaj grupę</span>
                                        </v-tooltip>
                                        <v-tooltip v-if="!isNewScreen" top :open-delay="tooltipDelay">
                                            <template #activator="{on}">
                                                <v-btn
                                                    icon
                                                    data-sentry-label="Edytuj grupę"
                                                    :disabled="!hasScreenGroup"
                                                    small
                                                    v-on="on"
                                                    @click="showEditOutdoorsLocalizationScreenGroupDialog"
                                                >
                                                    <v-icon color="teal">
                                                        mdi-pencil
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Edytuj grupę</span>
                                        </v-tooltip>
                                        <v-tooltip top :open-delay="tooltipDelay">
                                            <template #activator="{on}">
                                                <v-btn
                                                    icon
                                                    data-sentry-label="Usuń grupę"
                                                    :disabled="!hasScreenGroup"
                                                    small
                                                    v-on="on"
                                                    @click="showConfirmDeleteOutdoorsLocalizationScreenGroupDialog"
                                                >
                                                    <v-icon color="pink">
                                                        mdi-delete
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Usuń grupę</span>
                                        </v-tooltip>
                                    </template>
                                </v-select>
                            </v-col>
                            <v-col cols="12">
                                <v-select
                                    :value="outdoorsLocalizationScreen.localizationScreenSize"
                                    label="Rozmiar ekranu"
                                    :items="localizationScreenSizes"
                                    item-value="id"
                                    item-text="name"
                                    return-object
                                    no-data-text="Nie znaleziono rozmiarów ekranów"
                                    :error-messages="localizationScreenSizeErrors"
                                    outlined
                                    dense
                                    required
                                    @change="changeLocalizationScreenSize"
                                >
                                    <template slot="selection" slot-scope="data">
                                        {{ data.item.sizeA }} x {{ data.item.sizeB }}
                                    </template>

                                    <template slot="item" slot-scope="data">
                                        {{ data.item.sizeA }} x {{ data.item.sizeB }}
                                    </template>
                                    <template slot="append-outer">
                                        <v-tooltip top :open-delay="tooltipDelay">
                                            <template #activator="{on}">
                                                <v-btn
                                                    icon
                                                    data-sentry-label="Dodaj rozmiar"
                                                    small
                                                    v-on="on"
                                                    @click="showCreateOutdoorsLocalizationScreenSizeDialog"
                                                >
                                                    <v-icon color="primary">
                                                        mdi-plus
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Dodaj rozmiar</span>
                                        </v-tooltip>
                                        <v-tooltip v-if="!isNewScreen" top :open-delay="tooltipDelay">
                                            <template #activator="{on}">
                                                <v-btn
                                                    icon
                                                    data-sentry-label="Edytuj rozmiar"
                                                    :disabled="!hasScreenSize"
                                                    small
                                                    v-on="on"
                                                    @click="showEditOutdoorsLocalizationScreenSizeDialog"
                                                >
                                                    <v-icon color="teal">
                                                        mdi-pencil
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Edytuj rozmiar</span>
                                        </v-tooltip>
                                        <v-tooltip top :open-delay="tooltipDelay">
                                            <template #activator="{on}">
                                                <v-btn
                                                    icon
                                                    data-sentry-label="Usuń rozmiar"
                                                    :disabled="!hasScreenSize"
                                                    small
                                                    v-on="on"
                                                    @click="showConfirmDeleteOutdoorsLocalizationScreenSizeDialog"
                                                >
                                                    <v-icon color="pink">
                                                        mdi-delete
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Usuń rozmiar</span>
                                        </v-tooltip>
                                    </template>
                                </v-select>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-divider />

                <v-card-actions>
                    <v-btn
                        color="error"
                        text
                        data-sentry-label="Anuluj"
                        :disabled="actionLoading"
                        @click="onClose"
                    >
                        Anuluj
                    </v-btn>
                    <v-spacer />
                    <v-btn
                        color="success"
                        text
                        data-sentry-label="Zapisz"
                        :loading="actionLoading"
                        :disabled="!hasScreenSize || !hasScreenGroup"
                        @click="saveOutdoorsLocalizationScreen"
                    >
                        <template v-if="!isNewScreen">
                            Zapisz
                        </template>
                        <template v-else>
                            Dodaj
                        </template>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { isEmpty } from 'lodash'

import { required } from 'vuelidate/lib/validators'

import OutdoorsLocalizationScreenGroupDialog from '@/views/Outdoors/Common/OutdoorsLocalizationScreenGroupDialog'
import OutdoorsLocalizationScreenSizeDialog from './OutdoorsLocalizationScreenSizeDialog'
import ConfirmDialog from '@/components/common/ConfirmDialog'

import { errorHandler } from '@/utils/errorHandler'

import tooltipDelay from '@/mixins/tooltip'

export default {
    name: 'OutdoorsLocalizationScreenDialog',
    components: {
        OutdoorsLocalizationScreenGroupDialog,
        OutdoorsLocalizationScreenSizeDialog,
        ConfirmDialog
    },
    mixins: [
        tooltipDelay
    ],
    props: {
        isOpen: {
            type: Boolean
        },
        outdoorsLocalizationScreenData: {
            type: Object,
            default: null
        },
        outdoorsLocalizationData: {
            type: Object,
            default: null
        },
        customerData: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            outdoorsLocalizationScreen: {
                ordinalNumber: null,
                localizationScreenGroup: {
                    name: null
                },
                localizationScreenGroupId: null,
                localizationScreenSize: {
                    sizeA: null,
                    sizeB: null,
                },
                localizationScreenSizeId: null,
            },
            screenGroup: {},
            screenSize: {},
            actionLoading: false,
            outdoorsLocalizationScreenGroupDialog: false,
            confirmDeleteLocalizationScreenGroupDialog: false,
            outdoorsLocalizationScreenSizeDialog: false,
            confirmDeleteLocalizationScreenSizeDialog: false,
        }
    },
    computed: {
        localizationScreenGroups() {
            return this.$store.state.outdoors.outdoorsSettings.outdoorsLocalizationScreenGroups.localizationScreenGroups
        },
        localizationScreenSizes() {
            return this.$store.state.outdoors.outdoorsSettings.outdoorsLocalizationScreenSizes.localizationScreenSizes
        },
        hasScreenGroup() {
            return !!this.outdoorsLocalizationScreen.localizationScreenGroupId
        },
        hasScreenSize() {
            return !!this.outdoorsLocalizationScreen.localizationScreenSizeId
        },
        isNewScreen() {
            return isEmpty(this.outdoorsLocalizationScreenData)
        },
        ordinalNumberErrors() {
            const errors = []

            if (!this.$v.outdoorsLocalizationScreen.ordinalNumber.$dirty) return errors
            if (!this.$v.outdoorsLocalizationScreen.ordinalNumber.required)
                errors.push('Numer ekranu jest wymagany.')

            return errors
        },
        localizationScreenGroupErrors() {
            const errors = []

            if (!this.$v.outdoorsLocalizationScreen.localizationScreenGroupId.$dirty) return errors
            if (!this.$v.outdoorsLocalizationScreen.localizationScreenGroupId.required)
                errors.push('Grupa ekranu jest wymagana.')

            return errors
        },
        localizationScreenSizeErrors() {
            const errors = []

            if (!this.$v.outdoorsLocalizationScreen.localizationScreenSizeId.$dirty) return errors
            if (!this.$v.outdoorsLocalizationScreen.localizationScreenSizeId.required)
                errors.push('Rozmiar ekranu jest wymagany.')

            return errors
        }
    },
    validations: {
        outdoorsLocalizationScreen: {
            ordinalNumber: {
                required
            },
            localizationScreenGroupId: {
                required
            },
            localizationScreenSizeId: {
                required
            }
        }
    },
    watch: {
        isOpen(boolean) {
            if (boolean && !this.isNewScreen) {
                this.outdoorsLocalizationScreen = JSON.parse(JSON.stringify(this.outdoorsLocalizationScreenData))
            }
        },
    },
    methods: {
        getOutdoorsLocalizationScreenGroups() {
            this.$store.dispatch('outdoors/outdoorsSettings/getLocalizationScreenGroups', {
                paginate: '',
                query: `?customerId=${this.customerData.id}`
            })
                .catch(error => {
                    errorHandler(error)
                })
        },
        getOutdoorsLocalizationScreenSizes() {
            this.$store.dispatch('outdoors/outdoorsSettings/getLocalizationScreenSizes', {
                paginate: '',
                query: ''
            })
                .catch(error => {
                    errorHandler(error)
                })
        },
        updateScreen(screen) {
            this.outdoorsLocalizationScreen = screen
        },
        changeLocalizationScreenGroup(data) {
            this.outdoorsLocalizationScreen.localizationScreenGroup = data
            this.outdoorsLocalizationScreen.localizationScreenGroupId = data.id
        },
        changeLocalizationScreenSize(data) {
            this.outdoorsLocalizationScreen.localizationScreenSize = data
            this.outdoorsLocalizationScreen.localizationScreenSizeId = data.id
        },
        showCreateOutdoorsLocalizationScreenGroupDialog() {
            this.outdoorsLocalizationScreenGroupDialog = true
        },
        closeOutdoorsLocalizationScreenGroupDialog() {
            this.outdoorsLocalizationScreenGroupDialog = false

            setTimeout(() => {
                this.screenGroup = {}
            }, 500)
        },
        showEditOutdoorsLocalizationScreenGroupDialog() {
            this.screenGroup = JSON.parse(JSON.stringify(this.outdoorsLocalizationScreen.localizationScreenGroup))
            this.outdoorsLocalizationScreenGroupDialog = true
        },
        showConfirmDeleteOutdoorsLocalizationScreenGroupDialog() {
            this.confirmDeleteLocalizationScreenGroupDialog = true
        },
        closeConfirmDeleteOutdoorsLocalizationScreenGroupDialog() {
            this.confirmDeleteLocalizationScreenGroupDialog = false
        },
        deleteLocalizationScreenGroup() {
            this.$store.dispatch('outdoors/outdoorsSettings/deleteLocalizationScreenGroup', this.outdoorsLocalizationScreen.localizationScreenGroupId)
                .then(() => {
                    this.outdoorsLocalizationScreen.localizationScreenGroup = {}
                    this.outdoorsLocalizationScreen.localizationScreenGroupId = null
                    this.getOutdoorsLocalizationScreenGroups()
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.closeConfirmDeleteOutdoorsLocalizationScreenGroupDialog()
                })
        },
        showCreateOutdoorsLocalizationScreenSizeDialog() {
            this.outdoorsLocalizationScreenSizeDialog = true
        },
        showEditOutdoorsLocalizationScreenSizeDialog() {
            this.screenSize = JSON.parse(JSON.stringify(this.outdoorsLocalizationScreen.localizationScreenSize))
            this.outdoorsLocalizationScreenSizeDialog = true
        },
        closeOutdoorsLocalizationScreenSizeDialog() {
            this.outdoorsLocalizationScreenSizeDialog = false

            setTimeout(() => {
                this.screenSize = {}
            }, 500)
        },
        showConfirmDeleteOutdoorsLocalizationScreenSizeDialog() {
            this.confirmDeleteLocalizationScreenSizeDialog = true
        },
        closeConfirmDeleteOutdoorsLocalizationScreenSizeDialog() {
            this.confirmDeleteLocalizationScreenSizeDialog = false
        },
        deleteLocalizationScreenSize() {
            this.$store.dispatch('outdoors/outdoorsSettings/deleteLocalizationScreenSize', this.outdoorsLocalizationScreen.localizationScreenSizeId )
                .then(() => {
                    this.outdoorsLocalizationScreen.localizationScreenSize = {}
                    this.outdoorsLocalizationScreen.localizationScreenSizeId = null
                    this.getOutdoorsLocalizationScreenSizes()
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.closeConfirmDeleteOutdoorsLocalizationScreenSizeDialog()
                })
        },
        saveOutdoorsLocalizationScreen() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }

            this.actionLoading = true
            this.$emit('on-confirm', this.outdoorsLocalizationScreen)
            this.onClose()
        },
        onClose() {
            this.actionLoading = false

            setTimeout(() => {
                this.$v.$reset()
                this.outdoorsLocalizationScreen = {
                    ordinalNumber: null,
                    localizationScreenGroup: {
                        name: null
                    },
                    localizationScreenGroupId: null,
                    localizationScreenSize: {
                        sizeA: null,
                        sizeB: null,
                    },
                    localizationScreenSizeId: null,
                }
            }, 500)

            this.$emit('on-close')
        },
    }
}
</script>